import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classNames", "styles", "unstyled", "status", "apply", "children"];
import { jsx } from 'react/jsx-runtime';
import { Box, createPolymorphicComponent } from '@mantine/core';
import { forwardRef } from 'react';
import useStyles from './SecurityStatus.styles.js';
var _SecurityStatus = forwardRef(function (_ref, ref) {
  var classNames = _ref.classNames,
    styles = _ref.styles,
    unstyled = _ref.unstyled,
    status = _ref.status,
    _ref$apply = _ref.apply,
    apply = _ref$apply === void 0 ? "color" : _ref$apply,
    children = _ref.children,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(void 0, {
      name: "SecurityStatus",
      classNames: classNames,
      styles: styles,
      unstyled: unstyled
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var secStatusIndex = Math.min(Math.max(Math.round(status * 10), 0), 10);
  var classIndex = secStatusIndex.toString();
  var secStatus = (secStatusIndex / 10).toFixed(1);
  return /* @__PURE__ */jsx(Box, _objectSpread(_objectSpread({
    component: "span",
    ref: ref,
    className: cx(apply !== "background" ? classes.color : classes.background, classes[classIndex])
  }, others), {}, {
    children: children != null ? children : secStatus
  }));
});
_SecurityStatus.displayName = "SecurityStatus";
var SecurityStatus = createPolymorphicComponent(_SecurityStatus);
export { SecurityStatus };